/* DERWAL Blade Change Helper: 3D animation (product page stage, also used by the preview page). */
(function () {
  var stage = document.getElementById('stage');
  if (!stage || !stage.getAttribute('data-model')) return;
  var cv = document.getElementById('cv');
  var statusEl = document.getElementById('status');
  var labelEl = document.getElementById('colorLabel');
  var captionEl = document.getElementById('caption');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // texts follow the page language (English by default, Dutch on /nl)
  var NL = /^nl/i.test(document.documentElement.lang || '');
  function L(en, nl) { return NL ? nl : en; }
  if (!window.THREE) { statusEl.textContent = L('3D could not be loaded in this browser.', '3D kon niet worden geladen in deze browser.'); return; }

  // dimension overlay: created here when the page does not provide it
  if (!document.getElementById('dw-dims-style')) {
    var st = document.createElement('style'); st.id = 'dw-dims-style';
    st.textContent = '.stage .dims{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible}' +
      '.stage .dim-tag{position:absolute;left:0;top:0;pointer-events:none;white-space:nowrap;padding:3px 8px;font-family:Montserrat,"Helvetica Neue",Arial,sans-serif;font-weight:600;font-size:clamp(10px,1.15vw,13px);letter-spacing:.08em;color:#15171B;background:rgba(247,247,245,.82);border:1px solid rgba(20,21,24,.14);opacity:0}';
    document.head.appendChild(st);
  }
  var SVGNS = 'http://www.w3.org/2000/svg';
  var dimSvg = document.getElementById('dims'), dimTagsEl = document.getElementById('dimTags');
  var coAnchor = document.getElementById('co');
  if (!dimSvg) { dimSvg = document.createElementNS(SVGNS, 'svg'); dimSvg.setAttribute('class', 'dims'); dimSvg.id = 'dims'; dimSvg.setAttribute('aria-hidden', 'true'); stage.insertBefore(dimSvg, coAnchor); }
  if (!dimTagsEl) { dimTagsEl = document.createElement('div'); dimTagsEl.id = 'dimTags'; stage.insertBefore(dimTagsEl, coAnchor); }

  var COLORS = [{ name: 'Black', hex: 0x1B1C1E }, { name: 'Green', hex: 0x1F4A40 }, { name: 'Blue', hex: 0x22385A }];
  function lin(hex) { return new THREE.Color(hex).convertSRGBToLinear(); }

  var renderer;
  try { renderer = new THREE.WebGLRenderer({ canvas: cv, antialias: true, alpha: true }); }
  catch (e) { statusEl.textContent = L('3D is not supported in this browser.', '3D wordt niet ondersteund in deze browser.'); return; }
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 0.82;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  var scene = new THREE.Scene();
  var pmrem = new THREE.PMREMGenerator(renderer);
  scene.environment = pmrem.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
  var camera = new THREE.PerspectiveCamera(26, 16 / 9, 10, 2000);

  var key = new THREE.DirectionalLight(0xffffff, 1.25);
  key.position.set(-120, 240, 160); key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048);
  key.shadow.camera.left = -120; key.shadow.camera.right = 120; key.shadow.camera.top = 160; key.shadow.camera.bottom = -120;
  key.shadow.camera.near = 10; key.shadow.camera.far = 700; key.shadow.radius = 6; key.shadow.bias = -0.0004;
  scene.add(key);
  var rim = new THREE.DirectionalLight(0xffffff, 0.6); rim.position.set(160, 120, -180); scene.add(rim);
  scene.add(new THREE.HemisphereLight(0xffffff, 0xd8d8d4, 0.22));
  var ground = new THREE.Mesh(new THREE.PlaneGeometry(2000, 2000), new THREE.ShadowMaterial({ opacity: 0.18 }));
  ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);

  // Model frame (mm), measured from the part: round, Ø 64 × 15 high, centred on x and z, bottom on y = 0.
  // Rectangular pocket 45 (x) × 26 (z), 13 deep: floor at y = 2, rim at y = 15. Logo inlaid in the bottom face.
  var R = 32, H = 15, FLOOR = 2, PX = 45, PZ = 26;
  var turn = new THREE.Group(); scene.add(turn);
  var MID = 7.5;   // half the height: the helper tips over around its own middle
  var flip = new THREE.Group(); flip.position.y = MID; turn.add(flip);
  var model = new THREE.Group(); model.visible = false; model.position.y = -MID; flip.add(model);
  var bodyMat = new THREE.MeshStandardMaterial({ color: lin(COLORS[0].hex), roughness: 0.78, metalness: 0, envMapIntensity: 0.45 });
  var logoMat = new THREE.MeshStandardMaterial({ color: lin(0xEDEDEA), roughness: 0.6, envMapIntensity: 0.6 });
  var chrome = new THREE.MeshStandardMaterial({ color: lin(0xD9DDE2), metalness: 1, roughness: 0.18, envMapIntensity: 1.3 });
  var bladeMat = new THREE.MeshStandardMaterial({ color: lin(0xC9CDD3), metalness: 1, roughness: 0.22, envMapIntensity: 1.2 });
  var inkMat = new THREE.MeshBasicMaterial({ color: 0x141518, transparent: true, opacity: 0, depthTest: false, side: THREE.DoubleSide });

  function smooth(geo) {
    var U = THREE.BufferGeometryUtils;
    if (U && U.toCreasedNormals) return U.toCreasedNormals(geo, 0.6);
    geo.computeVertexNormals(); return geo;
  }

  // ----- razor (built here; not part of the CAD file), standing upside down: head at the bottom, handle up -----
  // Head local frame: x = across the head (42), z = front to back (22), y = up towards the handle.
  var razor = new THREE.Group(), handleGrp = new THREE.Group(), head = new THREE.Group();
  function yb(z) { return -1.6 * (1 - Math.pow(z / 11.2, 2)); }
  function arc(z0, z1, n, f) { var a = []; for (var i = 0; i <= n; i++) { var z = z0 + (z1 - z0) * i / n; a.push([z, f(z)]); } return a; }
  function headPart(pts, width, cornerR, steps) {
    var sh = new THREE.Shape(pts.map(function (p) { return new THREE.Vector2(p[0], p[1]); }));
    var geo = new THREE.ExtrudeGeometry(sh, { depth: width, steps: steps, bevelEnabled: false, curveSegments: 1 });
    geo.rotateY(Math.PI / 2); geo.translate(-width / 2, 0, 0);
    var pos = geo.attributes.position, half = width / 2, v;
    for (var i = 0; i < pos.count; i++) {
      var x = pos.getX(i), d = Math.abs(x) - (half - cornerR);
      if (d > 0) { v = Math.sqrt(Math.max(0.04, 1 - Math.pow(d / cornerR, 2))); pos.setZ(i, pos.getZ(i) * (0.55 + 0.45 * v)); pos.setY(i, pos.getY(i) * (0.7 + 0.3 * v)); }
    }
    return smooth(geo);
  }
  var capPts = arc(-10.2, 10.2, 40, function (z) { return yb(z) - 0.75 - 3.0 * Math.pow(Math.max(0, 1 - Math.pow(z / 10.2, 2)), 0.35); })
    .concat(arc(10.2, -10.2, 24, function (z) { return yb(z) - 0.04; }));
  var bladePts = arc(-11.2, 11.2, 30, function (z) { return yb(z); }).concat(arc(11.2, -11.2, 30, function (z) { return yb(z) + 0.1; }));
  var platePts = arc(-9.0, 9.0, 24, function (z) { return yb(z) + 0.14; })
    .concat([[9.4, 0.9]], arc(9.4, -9.4, 30, function (z) { return 1.5 + 2.3 * Math.pow(Math.max(0, 1 - Math.pow(z / 9.4, 2)), 1.5); }), [[-9.4, 0.9]]);
  var CAP_BOTTOM = 5.35;   // lowest point of the cap below the head origin
  // head parts that come apart for the blade change: the cap (with its stud) stays, blade and base plate lift
  var oldBladeMat = bladeMat.clone(); oldBladeMat.transparent = true;
  var newBladeMat = bladeMat.clone(); newBladeMat.transparent = true;
  var plateGrp = new THREE.Group(), oldBlade, newBlade;
  function buildRazor() {
    head.add(new THREE.Mesh(headPart(capPts, 43.4, 1.0, 44), chrome));
    var bladeGeo = headPart(bladePts, 43, 0.01, 4);
    // blade outline: planar UVs across (x) and front-to-back (z), and an alpha map with the usual DE cut-outs
    var bp = bladeGeo.attributes.position, buv = new Float32Array(bp.count * 2);
    for (var bi = 0; bi < bp.count; bi++) { buv[bi * 2] = (bp.getX(bi) + 21.5) / 43; buv[bi * 2 + 1] = (bp.getZ(bi) + 11.2) / 22.4; }
    bladeGeo.setAttribute('uv', new THREE.BufferAttribute(buv, 2));
    var ac = document.createElement('canvas'); ac.width = 430; ac.height = 224;
    var ag = ac.getContext('2d'); ag.fillStyle = '#fff'; ag.fillRect(0, 0, 430, 224); ag.fillStyle = '#000';
    function rr(cx, cy, w, h, r) { ag.beginPath(); ag.moveTo(cx - w / 2 + r, cy - h / 2); ag.arcTo(cx + w / 2, cy - h / 2, cx + w / 2, cy + h / 2, r); ag.arcTo(cx + w / 2, cy + h / 2, cx - w / 2, cy + h / 2, r); ag.arcTo(cx - w / 2, cy + h / 2, cx - w / 2, cy - h / 2, r); ag.arcTo(cx - w / 2, cy - h / 2, cx + w / 2, cy - h / 2, r); ag.fill(); }
    rr(215, 112, 200, 16, 8);                                       // centre slot
    ag.beginPath(); ag.arc(215, 112, 26, 0, Math.PI * 2); ag.fill();   // centre hole
    rr(88, 112, 30, 40, 12); rr(342, 112, 30, 40, 12);              // end holes
    ag.beginPath(); ag.moveTo(0, 96); ag.lineTo(14, 112); ag.lineTo(0, 128); ag.fill();      // notches in the short sides
    ag.beginPath(); ag.moveTo(430, 96); ag.lineTo(416, 112); ag.lineTo(430, 128); ag.fill();
    var atex = new THREE.CanvasTexture(ac);
    [oldBladeMat, newBladeMat].forEach(function (m) { m.alphaMap = atex; m.alphaTest = 0.5; m.side = THREE.DoubleSide; });
    newBladeMat.color = lin(0xDDE3EA);
    oldBlade = new THREE.Mesh(bladeGeo, oldBladeMat); head.add(oldBlade);
    newBlade = new THREE.Mesh(bladeGeo, newBladeMat); newBlade.visible = false; head.add(newBlade);
    plateGrp.add(new THREE.Mesh(headPart(platePts, 42, 0.8, 36), chrome));
    [-1, 1].forEach(function (sd) {
      var bar = new THREE.Mesh(new THREE.CylinderGeometry(0.65, 0.65, 41, 20), chrome); bar.rotation.z = Math.PI / 2; bar.position.set(0, 1.25, sd * 10.0); plateGrp.add(bar);
      for (var pi = -3; pi <= 3; pi++) { var post = new THREE.Mesh(new THREE.BoxGeometry(1.0, 0.9, 1.2), chrome); post.position.set(pi * 6.4, 1.35, sd * 9.5); plateGrp.add(post); }
    });
    head.add(plateGrp);
    // King C. Gillette style handle, 100 mm: neck at the bottom (on the head), butt end at the top
    var prof = [], Lh = 100;
    function P(r, y) { prof.push(new THREE.Vector2(r, y)); }
    P(0, 0); P(3.8, 0); P(4.8, 0.3); P(5.3, 1.2); P(5.4, 2.2); P(5.4, 45.2); P(5.2, 45.7);
    for (var k = 0; k < 46; k++) { var yk = 46 + k * 0.9; P(5.15, yk); P(5.55, yk + 0.3); P(5.55, yk + 0.45); P(5.15, yk + 0.75); }
    P(5.25, 87.6); P(5.15, 88.4); P(5.1, 95.6); P(5.45, 97.2); P(5.85, 98.6); P(5.7, 99.5); P(4.6, Lh); P(0, Lh);
    // cross-hatched knurl on the grip, so the handle visibly turns; the lathe's v follows the profile points
    var kc = document.createElement('canvas'); kc.width = 512; kc.height = 1024;
    var kg = kc.getContext('2d'); kg.fillStyle = '#ffffff'; kg.fillRect(0, 0, 512, 1024);
    var n = prof.length - 1, v0 = 1 - 190 / n, v1 = 1 - 7 / n;   // canvas rows (flipY) covering the grip points
    kg.save(); kg.beginPath(); kg.rect(0, v0 * 1024, 512, (v1 - v0) * 1024); kg.clip();
    kg.strokeStyle = 'rgba(70,74,80,0.85)'; kg.lineWidth = 3;
    for (var d = -1024; d < 1536; d += 32) { kg.beginPath(); kg.moveTo(d, 0); kg.lineTo(d + 512, 1024); kg.stroke(); kg.beginPath(); kg.moveTo(d + 512, 0); kg.lineTo(d, 1024); kg.stroke(); }
    kg.restore();
    var ktex = new THREE.CanvasTexture(kc); ktex.encoding = THREE.sRGBEncoding; ktex.anisotropy = 8;
    var handleMat = chrome.clone(); handleMat.map = ktex;
    var handle = new THREE.Mesh(new THREE.LatheGeometry(prof, 72), handleMat);
    handle.rotation.z = Math.PI; handle.position.y = 3.8 + Lh;
    handleGrp.add(handle);
    // threaded stud of the cap: hidden inside the handle, it shows once the handle is off
    var th = [], ty0 = 3.6, ty1 = 10.2;
    th.push(new THREE.Vector2(0, ty0)); th.push(new THREE.Vector2(2.05, ty0));
    for (var yy = ty0 + 0.2; yy < ty1 - 0.4; yy += 0.8) { th.push(new THREE.Vector2(2.4, yy + 0.2)); th.push(new THREE.Vector2(2.05, yy + 0.6)); }
    th.push(new THREE.Vector2(1.8, ty1)); th.push(new THREE.Vector2(0, ty1));
    head.add(new THREE.Mesh(new THREE.LatheGeometry(th, 32), chrome));
    razor.add(head); razor.add(handleGrp);
    razor.traverse(function (o) { if (o.isMesh) { o.castShadow = true; o.receiveShadow = true; } });
    razor.position.y = FLOOR + CAP_BOTTOM;
    model.add(razor);
  }

  // a curved arrow around the handle shows the twist (the round handle itself shows no rotation)
  var twist = new THREE.Group();
  var arcGeo = new THREE.TorusGeometry(13, 0.9, 10, 48, Math.PI * 1.45);
  var arcMesh = new THREE.Mesh(arcGeo, inkMat); arcMesh.rotation.x = Math.PI / 2; twist.add(arcMesh);   // (cos a, sin a, 0) -> (cos a, 0, sin a)
  // arc runs from +x towards +z (clockwise seen from above); the arrow head points along the arc's end
  var A_END = Math.PI * 1.45, tip = new THREE.Mesh(new THREE.ConeGeometry(2.6, 5.5, 16), inkMat);
  tip.position.set(13 * Math.cos(A_END), 0, 13 * Math.sin(A_END));
  tip.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), new THREE.Vector3(-Math.sin(A_END), 0, Math.cos(A_END)));
  twist.add(tip); twist.renderOrder = 10; twist.visible = false;
  model.add(twist);

  // outline of the pocket's opening
  var hlPts = [[-PX / 2, -PZ / 2], [PX / 2, -PZ / 2], [PX / 2, PZ / 2], [-PX / 2, PZ / 2], [-PX / 2, -PZ / 2]].map(function (q) { return new THREE.Vector3(q[0], H + 0.15, q[1]); });
  var hl = new THREE.Line(new THREE.BufferGeometry().setFromPoints(hlPts), new THREE.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0 }));
  model.add(hl);

  // ---------- timeline ----------
  var BASE = -0.5, LOGO = 2.6, CYCLE = 28.6 + LOGO;
  var colorIdx = 0, fromC = lin(COLORS[0].hex), toC = lin(COLORS[0].hex), mixK = 1, cycleOn = !reduce;
  var t = 0, last = null, loaded = false, lastCyc = -1;
  var userYaw = 0, dragging = false, dragX = 0, idle = 0;
  function ease(x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function clamp(x) { return Math.max(0, Math.min(1, x)); }
  function seg(x, a, b) { return clamp((x - a) / (b - a)); }

  function setColor(i, instant) {
    colorIdx = i; fromC = bodyMat.color.clone(); toC = lin(COLORS[i].hex); mixK = instant ? 1 : 0;
    if (instant) bodyMat.color.copy(toC);
    var sw = document.querySelector('#swatches button[data-c="' + i + '"]');
    if (labelEl) labelEl.textContent = (sw && sw.getAttribute('data-name')) || COLORS[i].name;
    document.querySelectorAll('#swatches button').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.c === i)); });
  }
  var lastCap = null;
  function caption(txt) { if (captionEl && txt !== lastCap) { lastCap = txt; captionEl.textContent = txt; } }

  // ----- dimension lines, drawn in the SVG overlay from points on the model -----
  function V(x, y, z) { return new THREE.Vector3(x, y, z); }
  var DIMS = {
    outer: [
      { a: V(-R, 0, 0), b: V(R, 0, 0), o: V(0, 0, 1), off: 42, text: '\u00D8 64 mm' },
      { a: V(R, 0, 0), b: V(R, H, 0), o: V(1, 0, 0), off: 10, text: '15 mm' }
    ],
    pocket: [
      { a: V(-PX / 2, H, PZ / 2), b: V(PX / 2, H, PZ / 2), o: V(0, 0, 1), off: 10, text: '45 mm' },
      { a: V(PX / 2, H, PZ / 2), b: V(PX / 2, H, -PZ / 2), o: V(1, 0, 0), off: 5, text: '26 mm' },
      { a: V(-12, FLOOR, -PZ / 2 + 0.1), b: V(-12, H, -PZ / 2 + 0.1), o: V(0, 0, 1), off: 0.01, text: L('13 mm deep', '13 mm diep') }
    ]
  };
  var dimEls = [];
  Object.keys(DIMS).forEach(function (grp) {
    DIMS[grp].forEach(function (d) {
      var g = document.createElementNS(SVGNS, 'g'); g.setAttribute('stroke', '#141518'); g.setAttribute('stroke-width', '1.2'); g.style.opacity = 0;
      var ls = []; for (var i = 0; i < 5; i++) { var l = document.createElementNS(SVGNS, 'line'); g.appendChild(l); ls.push(l); }
      ls[1].setAttribute('stroke-dasharray', '3 3'); ls[2].setAttribute('stroke-dasharray', '3 3'); ls[1].setAttribute('stroke-width', '0.8'); ls[2].setAttribute('stroke-width', '0.8');
      dimSvg.appendChild(g);
      var tag = document.createElement('div'); tag.className = 'dim-tag'; tag.textContent = d.text; dimTagsEl.appendChild(tag);
      dimEls.push({ grp: grp, d: d, g: g, ls: ls, tag: tag });
    });
  });
  var pv = new THREE.Vector3();
  function scr(p, r) { pv.copy(p); model.localToWorld(pv); pv.project(camera); return [(pv.x + 1) / 2 * r.width, (1 - pv.y) / 2 * r.height]; }
  function updateDims(alpha) {
    var r = stage.getBoundingClientRect();
    scene.updateMatrixWorld();
    dimEls.forEach(function (e) {
      var a = alpha[e.grp] || 0;
      e.g.style.opacity = a; e.tag.style.opacity = a;
      if (a <= 0) return;
      var d = e.d, oa = d.a.clone().addScaledVector(d.o, d.off), ob = d.b.clone().addScaledVector(d.o, d.off);
      var A = scr(d.a, r), B = scr(d.b, r), OA = scr(oa, r), OB = scr(ob, r);
      function set(l, p, q) { l.setAttribute('x1', p[0]); l.setAttribute('y1', p[1]); l.setAttribute('x2', q[0]); l.setAttribute('y2', q[1]); }
      set(e.ls[0], OA, OB); set(e.ls[1], A, OA); set(e.ls[2], B, OB);
      var dx = OB[0] - OA[0], dy = OB[1] - OA[1], len = Math.hypot(dx, dy) || 1, nx = -dy / len * 5, ny = dx / len * 5;
      set(e.ls[3], [OA[0] - nx, OA[1] - ny], [OA[0] + nx, OA[1] + ny]);
      set(e.ls[4], [OB[0] - nx, OB[1] - ny], [OB[0] + nx, OB[1] + ny]);
      var mx = (OA[0] + OB[0]) / 2, my = (OA[1] + OB[1]) / 2, ex = mx - (A[0] + B[0]) / 2, ey = my - (A[1] + B[1]) / 2, el = Math.hypot(ex, ey);
      // a dimension drawn on the surface (no offset) gets its label beside the line instead of on it
      if (el < 2) { ex = -dy / len; ey = dx / len; if (ex > 0) { ex = -ex; ey = -ey; } el = 1; mx += ex * 34; my += ey * 34; }
      else { mx += ex / el * 12; my += ey / el * 12; }
      e.tag.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';
    });
  }

  // callouts: dot on the model, a line, and a label in a subtle box
  var coSvg = document.getElementById('co'), coLine = document.getElementById('coLine'), coDot = document.getElementById('coDot');
  var coText = document.getElementById('coText'), coTitle = document.getElementById('coTitle'), coSub = document.getElementById('coSub');
  var CALLOUTS = {
    1: { at: V(PX / 2 - 3, H, PZ / 2), title: L('Holds the head', 'Houdt het hoofd vast'), sub: L('Cap down, in the pocket', 'Kap omlaag, in de uitsparing') },
    2: { at: V(9, FLOOR + CAP_BOTTOM - 1.5, 0), title: L('Safely change the blade', 'Veilig je mesje wisselen'), sub: L('The cap stays put in the pocket', 'De kap blijft in de uitsparing staan') }
  };
  var lastCo = 0, coV = new THREE.Vector3();
  function updateCallout(id, a) {
    if (!coSvg) return;
    if (!id || a <= 0) { coSvg.style.opacity = 0; coText.style.opacity = 0; return; }
    var d = CALLOUTS[id];
    if (id !== lastCo) { lastCo = id; coTitle.textContent = d.title; coSub.textContent = d.sub; }
    scene.updateMatrixWorld();
    coV.copy(d.at); model.localToWorld(coV); coV.project(camera);
    var r = stage.getBoundingClientRect(), Wd = r.width, Hd = r.height;
    var sx = (coV.x + 1) / 2 * Wd, sy = (1 - coV.y) / 2 * Hd;
    var tw = coText.offsetWidth || 240, th = coText.offsetHeight || 50, gap = Math.max(50, Wd * 0.08);
    var right = sx + gap + tw < Wd - 16;
    var lx = right ? sx + gap : sx - gap, ly = Math.max(th / 2 + 8, sy - Math.min(48, Hd * 0.08));
    coDot.setAttribute('cx', sx); coDot.setAttribute('cy', sy);
    coLine.setAttribute('x1', sx); coLine.setAttribute('y1', sy);
    coLine.setAttribute('x2', lx); coLine.setAttribute('y2', ly);
    coText.style.transform = 'translate(' + (right ? lx : lx - tw) + 'px,' + ly + 'px) translateY(-50%)';
    coSvg.style.opacity = a; coText.style.opacity = a;
  }

  // camera: focus = look down into the pocket; tall = frame the razor standing in it
  var camDist = 250, camFocus = -1, camTall = -1, camZoom = 0;
  function placeCamera(focus, tall, zoom) {
    zoom = zoom || 0;
    var elev = (30 + 26 * focus + 2 * tall - 8 * zoom) * Math.PI / 180;
    var ty = 6 + 46 * tall - 24 * zoom;
    var dist = camDist * (1 - 0.3 * focus + 0.62 * tall) * (1 - 0.42 * zoom);
    camera.position.set(0, ty + Math.sin(elev) * dist, Math.cos(elev) * dist);
    camera.lookAt(0, ty, 0);
  }
  function resize() {
    var r = stage.getBoundingClientRect();
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(r.width, r.height, false);
    camera.aspect = r.width / r.height;
    camDist = r.width / r.height < 1.2 ? 330 : 250;
    camera.updateProjectionMatrix();
    placeCamera(Math.max(0, camFocus), Math.max(0, camTall), camZoom);
  }

  function pose(time) {
    var p = { yaw: BASE, flipK: 0, zoom: 0, plateUp: 0, bladeUp: 0, oldOut: 0, newIn: 0, swapped: 0, dims: { outer: 0, pocket: 0 }, focus: 0, tall: 0, hl: 0, inK: 0, spin: 0, rise: 0, lift: 0, out: 0, tw: 0, twDir: 1, co: 0, coA: 0 };
    if (reduce) { p.inK = 1; p.tall = 1; return p; }
    var c0 = time % CYCLE;
    // 0) one quick roll in the air to show the logo underneath
    p.flipK = ease(seg(c0, 0.2, 2.4));
    if (c0 < LOGO) { p.tall = 0.45 * Math.sin(Math.PI * p.flipK); caption(c0 > 0.6 && c0 < 2.2 ? L('DERWAL logo underneath', 'DERWAL-logo aan de onderkant') : ''); return p; }
    var c = c0 - LOGO;
    // 1) outer size
    p.dims.outer = Math.min(seg(c, 0.8, 1.3), 1 - seg(c, 4.6, 5.0));
    // 2) look down into the pocket and measure it
    p.focus = ease(seg(c, 5.0, 6.2)) * (1 - ease(seg(c, 10.0, 11.2)));
    p.hl = Math.min(seg(c, 6.0, 6.4), 1 - seg(c, 9.6, 10.0));
    p.dims.pocket = Math.min(seg(c, 6.2, 6.7), 1 - seg(c, 9.6, 10.0));
    // 3) the razor comes down head first into the pocket
    p.tall = ease(seg(c, 10.0, 11.6)) * (1 - ease(seg(c, 24.6, 25.8)));
    p.inK = ease(seg(c, 10.8, 12.6));
    if (c >= 12.8 && c < 14.6) { p.co = 1; p.coA = Math.min(seg(c, 12.8, 13.15), 1 - seg(c, 14.25, 14.6)); }
    // 4) twist the handle off (3 turns, rising with the thread), lift it away
    var un = seg(c, 14.6, 17.4);
    p.spin = Math.PI * 6 * ease(un); p.rise = 3.2 * ease(un);
    p.tw = Math.min(seg(c, 14.6, 14.9), 1 - seg(c, 17.1, 17.4)); p.twDir = -1;
    p.lift = ease(seg(c, 17.4, 18.6));
    // 5) blade change, exploded: base plate and blade lift off the stud, the old blade slides out, a new one in
    p.zoom = ease(seg(c, 18.4, 19.4)) * (1 - ease(seg(c, 23.4, 24.4)));
    var apart = ease(seg(c, 18.8, 19.8)) * (1 - ease(seg(c, 22.6, 23.6)));
    p.plateUp = apart; p.bladeUp = apart;
    p.oldOut = ease(seg(c, 19.9, 20.9)); p.newIn = ease(seg(c, 21.0, 22.2)); p.swapped = c >= 21.0 ? 1 : 0;
    if (c >= 19.9 && c < 23.2) { p.co = 2; p.coA = Math.min(seg(c, 19.9, 20.25), 1 - seg(c, 22.85, 23.2)); }
    // 6) put the handle back and screw it on again
    if (c >= 23.6) {
      p.lift = 1 - ease(seg(c, 23.6, 24.6));
      var on = seg(c, 24.6, 27.0);
      p.spin = Math.PI * 6 * (1 - ease(on)); p.rise = 3.2 * (1 - ease(on));
      p.tw = Math.min(seg(c, 24.6, 24.9), 1 - seg(c, 26.7, 27.0)); p.twDir = 1;
    }
    // 7) the whole razor is lifted out
    p.out = ease(seg(c, 27.2, 28.2));
    if (c < 0.8) caption('');
    else if (c < 5.0) caption(L('Outer size', 'Buitenmaat'));
    else if (c < 10.4) caption(L('The pocket for the head', 'De uitsparing voor het hoofd'));
    else if (c < 14.6) caption(L('Head first, into the pocket', 'Met het hoofd omlaag erin'));
    else if (c < 18.8) caption(L('Twist the handle off', 'Draai het handvat los'));
    else if (c < 23.6) caption(L('Swap the blade', 'Wissel het mesje'));
    else if (c < 27.2) caption(L('Screw it back on', 'Draai het weer vast'));
    else caption('');
    if (cycleOn) { var cyc = Math.floor(time / CYCLE); if (c0 >= CYCLE - 0.3 && lastCyc !== cyc) { lastCyc = cyc; setColor((colorIdx + 1) % COLORS.length); } }
    return p;
  }

  function frame(now) {
    if (stage.dataset.paused === '1') { last = now; requestAnimationFrame(frame); return; }
    var dt = last == null ? 0 : Math.min(0.05, (now - last) / 1000); last = now;
    if (loaded) {
      t += dt;
      var p = pose(t);
      if (!dragging) { idle += dt; if (idle > 2.5) userYaw *= Math.pow(0.15, dt); }
      var sway = reduce ? 0 : 0.06 * Math.sin(t * 0.7);
      turn.rotation.y = p.yaw + sway + userYaw;
      // lifted high enough while it rolls that no corner goes through the floor
      var fk = p.flipK % 1;
      flip.rotation.x = -Math.PI * 2 * fk;
      flip.position.y = MID + 40 * Math.sqrt(Math.max(0, Math.sin(Math.PI * fk)));
      if (p.focus !== camFocus || p.tall !== camTall || p.zoom !== camZoom) { camFocus = p.focus; camTall = p.tall; camZoom = p.zoom; placeCamera(camFocus, camTall, camZoom); }
      // razor: comes down from above, leaves straight up
      var fall = 1 - p.inK;
      razor.visible = p.inK > 0 && p.out < 1;
      razor.position.y = FLOOR + CAP_BOTTOM + 120 * fall * fall + 140 * p.out * p.out;
      // exploded head: plate highest, blade between plate and cap; old blade out to the right, new one in from the left
      if (oldBlade) {
        plateGrp.position.y = 30 * p.plateUp;
        oldBlade.visible = p.swapped < 1; newBlade.visible = p.swapped >= 1;
        oldBlade.position.set(64 * p.oldOut, 15 * p.bladeUp + 6 * p.oldOut, 0); oldBladeMat.opacity = 1 - p.oldOut; oldBlade.castShadow = p.oldOut < 0.3;
        newBlade.position.set(-64 * (1 - p.newIn), 15 * p.bladeUp + 6 * (1 - p.newIn), 0); newBladeMat.opacity = p.newIn; newBlade.castShadow = p.newIn > 0.7;
        if (p.oldOut === 0 && p.newIn === 0) { oldBladeMat.opacity = 1; }
      }
      handleGrp.rotation.y = p.spin;
      handleGrp.position.y = p.rise + 22 * p.lift;
      handleGrp.position.x = -44 * p.lift * p.lift;
      // twist arrow around the handle, just above the pocket
      twist.visible = p.tw > 0; inkMat.opacity = p.tw * 0.9;
      twist.position.set(0, razor.position.y + 34 + p.rise, 0);
      twist.scale.set(1, 1, p.twDir);   // -1 mirrors the arrow to anticlockwise (unscrew)
      twist.rotation.y = p.twDir > 0 ? Math.PI : 0;   // keep the arrow head on the side facing the camera
      hl.material.opacity = p.hl; hl.visible = p.hl > 0;
      updateDims(p.dims);
      updateCallout(p.co, p.coA);
      if (mixK < 1) { mixK = Math.min(1, mixK + dt / 0.8); bodyMat.color.copy(fromC).lerp(toC, ease(mixK)); }
    }
    renderer.render(scene, camera);
    requestAnimationFrame(frame);
  }

  stage.addEventListener('pointerdown', function (e) { dragging = true; dragX = e.clientX; idle = 0; stage.setPointerCapture(e.pointerId); });
  stage.addEventListener('pointermove', function (e) { if (!dragging) return; userYaw += (e.clientX - dragX) * 0.008; dragX = e.clientX; });
  function endDrag() { dragging = false; idle = 0; }
  stage.addEventListener('pointerup', endDrag); stage.addEventListener('pointercancel', endDrag);
  // the swatches choose the colour (on the product page: the variant); the 3D follows and stops cycling
  var cycleBtn = document.getElementById('cycle');
  function setCycle(on) { cycleOn = on; if (cycleBtn) { cycleBtn.setAttribute('aria-pressed', String(on)); cycleBtn.textContent = L('Cycle colours: ', 'Kleuren wisselen: ') + (on ? L('on', 'aan') : L('off', 'uit')); } }
  if (cycleBtn) cycleBtn.addEventListener('click', function () { setCycle(!cycleOn); });
  document.querySelectorAll('#swatches button').forEach(function (b) { b.addEventListener('click', function () { setCycle(false); setColor(+b.dataset.c, false); }); });
  var replayBtn = document.getElementById('replay');
  if (replayBtn) replayBtn.addEventListener('click', function () { t = 0; lastCyc = -1; userYaw = 0; });
  var pre = document.querySelector('#swatches button[aria-pressed="true"]');
  if (pre) setColor(+pre.dataset.c, true);
  if (reduce) setCycle(false);

  stage.dwSeek = function (s) { t = s; };   // lets a preview jump to a moment in the timeline
  if (window.ResizeObserver) new ResizeObserver(resize).observe(stage); else window.addEventListener('resize', resize);
  resize();
  requestAnimationFrame(frame);

  // ---------- loading ----------
  function fail(msg) { statusEl.hidden = false; statusEl.textContent = L('The model could not be loaded', 'Het model kon niet worden geladen') + ' (' + String(msg).slice(0, 120) + ').'; }
  // glTF JSON with one base64 buffer -> binary glTF in memory (for pages whose security policy blocks data: URLs)
  function toGLB(json) {
    var uri = json.buffers[0].uri, b64 = uri.slice(uri.indexOf(',') + 1);
    var raw = atob(b64), bin = new Uint8Array(raw.length);
    for (var i = 0; i < raw.length; i++) bin[i] = raw.charCodeAt(i);
    delete json.buffers[0].uri;
    var jsonBytes = new TextEncoder().encode(JSON.stringify(json));
    var jsonPad = (4 - jsonBytes.length % 4) % 4, binPad = (4 - bin.length % 4) % 4;
    var jl = jsonBytes.length + jsonPad, bl = bin.length + binPad, total = 12 + 8 + jl + 8 + bl;
    var out = new ArrayBuffer(total), dv = new DataView(out), u8 = new Uint8Array(out);
    dv.setUint32(0, 0x46546C67, true); dv.setUint32(4, 2, true); dv.setUint32(8, total, true);
    dv.setUint32(12, jl, true); dv.setUint32(16, 0x4E4F534A, true);
    u8.set(jsonBytes, 20); for (i = 0; i < jsonPad; i++) u8[20 + jsonBytes.length + i] = 0x20;
    dv.setUint32(20 + jl, bl, true); dv.setUint32(24 + jl, 0x004E4942, true);
    u8.set(bin, 28 + jl);
    return out;
  }
  // smooth chrome needs BufferGeometryUtils (creased normals); load it if the page has not
  function withUtils(cb) {
    if (THREE.BufferGeometryUtils) return cb();
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/three@0.147.0/examples/js/utils/BufferGeometryUtils.js';
    s.onload = cb; s.onerror = cb; document.head.appendChild(s);
  }
  var src = stage.getAttribute('data-model'), asJson = /\.json(\?|$)/.test(src);
  var xhr = new XMLHttpRequest();
  xhr.open('GET', src); xhr.responseType = asJson ? 'text' : 'arraybuffer'; xhr.timeout = 60000;
  xhr.onprogress = function (ev) { if (ev.total) statusEl.textContent = L('Loading model\u2026 ', 'Model laden\u2026 ') + Math.round(ev.loaded / ev.total * 100) + '%'; };
  xhr.onerror = function () { fail('network error'); };
  xhr.ontimeout = function () { fail('timed out'); };
  xhr.onload = function () {
    if (xhr.status && xhr.status !== 200) { fail('HTTP ' + xhr.status); return; }
    var glb;
    try { glb = asJson ? toGLB(JSON.parse(xhr.responseText)) : xhr.response; } catch (e) { fail('could not read the file'); return; }
    withUtils(function () {
      new THREE.GLTFLoader().parse(glb, '', function (gltf) {
        gltf.scene.traverse(function (o) {
          if (!o.isMesh) return;
          var name = o.name || (o.parent && o.parent.name) || '';
          if (/Logo/.test(name)) { o.geometry = o.geometry.index ? o.geometry.toNonIndexed() : o.geometry; o.geometry.computeVertexNormals(); o.material = logoMat; }
          else { o.geometry = smooth(o.geometry); o.material = bodyMat; o.castShadow = true; o.receiveShadow = true; }
        });
        model.add(gltf.scene);
        buildRazor();
        statusEl.hidden = true; loaded = true; model.visible = true;
      }, function (e) { fail(e && e.message ? e.message : 'parse error'); });
    });
  };
  xhr.send();
})();
